import React, { useEffect, Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';

const HomeBelowFold = lazy(() => import('@/components/HomeBelowFold'));

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const scroll = () => {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return !!el;
    };
    // The target section may live in the lazily loaded chunk — retry briefly.
    if (scroll()) return;
    const t = setInterval(() => {
      if (scroll()) clearInterval(t);
    }, 120);
    const stop = setTimeout(() => clearInterval(t), 3000);
    return () => {
      clearInterval(t);
      clearTimeout(stop);
    };
  }, [hash]);

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={<div className="h-screen" />}>
          <HomeBelowFold />
        </Suspense>
      </main>
    </div>
  );
}